import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Col, Row } from '../../lib/utils';
import { Head4, Body2Bold, Body3Regular, Body3Bold, CaptionRegular } from '../../lib/font';
import { colors } from '../../lib/colors';
import { getPaymentRequest, formatPrice } from './data/dummyData';
import PaymentHeader from './components/PaymentHeader';
import StickyBottomButton from './components/StickyBottomButton';

const MemberPaymentCheckoutPage: React.FC = () => {
    const { paymentRequestId } = useParams<{ paymentRequestId: string }>();
    const navigate = useNavigate();

    const data = getPaymentRequest(paymentRequestId || '');

    if (!data) {
        return (
            <Col style={{ width: '100%', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F5F7FA' }}>
                <Body2Bold style={{ color: colors.ERROR }}>요청을 찾을 수 없습니다</Body2Bold>
            </Col>
        );
    }

    const handlePayment = () => {
        navigate(`/pay/${paymentRequestId}/mock-pg?type=payment`);
    };

    return (
        <Col style={{ width: '100%', minHeight: '100vh', alignItems: 'center', backgroundColor: '#F5F7FA' }}>
            <Col style={{ width: '100%', maxWidth: 480, minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
                <PaymentHeader title="결제 확인" />

                <Col style={{ flex: 1, padding: '16px', paddingBottom: 80, gap: 12 }}>
                    {/* 수강권 요약 */}
                    <Col
                        style={{
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: 16,
                            padding: '24px 20px',
                            alignItems: 'center',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                        }}
                    >
                        <CaptionRegular style={{ color: colors.LAVEL_2 }}>
                            {data.ticketType} · 선결제
                        </CaptionRegular>
                        <Body2Bold style={{ color: colors.LAVEL_4, marginTop: 4 }}>
                            {data.ticketName}
                        </Body2Bold>
                        <Head4 style={{ color: colors.primary, marginTop: 12, fontSize: 32 }}>
                            {formatPrice(data.totalPrice)}원
                        </Head4>
                    </Col>

                    {/* 결제 상세 */}
                    <Col
                        style={{
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: 16,
                            padding: '24px 20px',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                        }}
                    >
                        <Body3Bold style={{ color: colors.LAVEL_4, marginBottom: 16 }}>결제 상세 내역</Body3Bold>

                        <Row style={{ justifyContent: 'space-between', padding: '8px 0' }}>
                            <Body3Regular style={{ color: colors.LAVEL_2 }}>수강권명</Body3Regular>
                            <Body3Regular style={{ color: colors.LAVEL_4 }}>{data.ticketName}</Body3Regular>
                        </Row>
                        <Row style={{ justifyContent: 'space-between', padding: '8px 0' }}>
                            <Body3Regular style={{ color: colors.LAVEL_2 }}>담당 트레이너</Body3Regular>
                            <Body3Regular style={{ color: colors.LAVEL_4 }}>{data.trainerName}</Body3Regular>
                        </Row>
                        <Row style={{ justifyContent: 'space-between', padding: '8px 0' }}>
                            <Body3Regular style={{ color: colors.LAVEL_2 }}>이용 기간</Body3Regular>
                            <Body3Regular style={{ color: colors.LAVEL_4 }}>
                                {data.startDate} ~ {data.endDate}
                            </Body3Regular>
                        </Row>
                        <Row style={{ justifyContent: 'space-between', padding: '8px 0' }}>
                            <Body3Regular style={{ color: colors.LAVEL_2 }}>이용 횟수</Body3Regular>
                            <Body3Regular style={{ color: colors.LAVEL_4 }}>{data.sessionCount}회</Body3Regular>
                        </Row>

                        <div style={{ width: '100%', height: 1, backgroundColor: '#F0F0F0', margin: '12px 0' }} />

                        <Row style={{ justifyContent: 'space-between', padding: '8px 0' }}>
                            <Body3Regular style={{ color: colors.LAVEL_2 }}>이용권 금액</Body3Regular>
                            <Body3Regular style={{ color: colors.LAVEL_4 }}>{formatPrice(data.totalPrice)}원</Body3Regular>
                        </Row>

                        <div style={{ width: '100%', height: 1, backgroundColor: colors.LAVEL_4, margin: '12px 0' }} />

                        <Row style={{ justifyContent: 'space-between', padding: '4px 0' }}>
                            <Body2Bold style={{ color: colors.LAVEL_4 }}>총 결제 금액</Body2Bold>
                            <Head4 style={{ color: colors.primary }}>{formatPrice(data.totalPrice)}원</Head4>
                        </Row>
                    </Col>

                    {/* 안내 문구 */}
                    <Col
                        style={{
                            width: '100%',
                            padding: '14px 16px',
                            backgroundColor: '#FAFAFA',
                            borderRadius: 8,
                        }}
                    >
                        <CaptionRegular style={{ color: colors.LAVEL_2, textAlign: 'center', lineHeight: '18px' }}>
                            결제 진행 시 위 내용에 동의하는 것으로 간주됩니다
                        </CaptionRegular>
                        <CaptionRegular style={{ color: colors.LAVEL_1, textAlign: 'center', lineHeight: '18px', marginTop: 4 }}>
                            결제 완료 후 트레이너에게 자동으로 알림이 발송됩니다
                        </CaptionRegular>
                    </Col>
                </Col>

                <StickyBottomButton
                    text={`${formatPrice(data.totalPrice)}원 결제하기`}
                    onClick={handlePayment}
                />
            </Col>
        </Col>
    );
};

export default MemberPaymentCheckoutPage;
